<script lang="ts">
	import type { PoiFilterId } from '../../types';
	import Switch from '$lib/components/atoms/switch/Switch.svelte';
	import { getSearchParamsStore } from '$lib/services/urls/searchParams';
	import { createEventDispatcher } from 'svelte';

	export let id: PoiFilterId;
	export let name: string;
	export let defaultValue: boolean;

	const searchParams = getSearchParamsStore(false);
	const dispatch = createEventDispatcher<{
		change: { id: PoiFilterId; value: boolean | undefined };
	}>();

	function handlerChange(target: EventTarget | null) {
		if (!target) {
			return;
		}

		const { checked } = target as HTMLInputElement;

		dispatch('change', { id, value: checked === defaultValue ? undefined : checked });
	}

	$: checked = ($searchParams.filters?.[id] ?? defaultValue) as boolean;
</script>

<Switch
	{id}
	text={name}
	{checked}
	onchange={({ target }) => {
		handlerChange(target);
	}}
/>
